import { ComponentPublicInstance, createApp, h, nextTick } from "vue";

import { v4 as uuid } from 'uuid';
import {Popup} from "mapbox-gl";

export interface VueMapPopupOptions extends mapboxgl.PopupOptions {
  className: string;
}

export class VueMapPopup<ComponentType> extends Popup {
  private _enclosure;
  private _componentInstance;
  public uid: string;
  private localApp;

  constructor(private component, private properties: any = {}, options: Partial<VueMapPopupOptions> = {}) {
    super({
      closeButton: false,
      closeOnMove: false,
      closeOnClick: false,
      anchor: "center",
      className: options.className ?? 'transparent-popup',
      ...options
    });
  }

  addTo(map: mapboxgl.Map): this {
    this._enclosure = document.createElement('div');
    nextTick(() => {
      this.createComponent({
        component: this.component,
        props: { ...this.properties, mapController: (map as any)._controller },
        el: this._enclosure
      })
    }).then(() => {
    });
    this.setDOMContent(this._enclosure);
    super.addTo(map);
    return this;
  }

  remove(){
    super.remove();
    this.localApp?.unmount();

    return this;
  }

  createComponent({ component, props, el }) {

    let app = (window as any).mainApp;

    this.uid = uuid();

    let expose = null

    const childApp = createApp({
      render: () => expose = h(component, {
        ...props,
        ref: this.uid,
        input: (event) => console.log('input event', event)
      })
    })

    Object.assign(childApp._context, app._context)
    this.localApp = childApp;

    this._componentInstance = childApp.mount(el);

    return expose.component.exposed
  }

  ctx(): ComponentType {
    return this._componentInstance?.$refs[this.uid];
  }
}
